import { ConfirmDialogProvider } from "@/components/confirm-dialog";
import Loader from "@/components/loader";
import { TooltipProvider } from "@/components/ui/tooltip";

import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, Suspense } from "react";
import { Toaster } from "react-hot-toast";

// Everything around the router that both the browser (main.jsx, App.jsx)
// and the server render (entry-server.jsx) share. The hydrated tree must be
// identical to the server tree down to each fragment, otherwise `useId`
// values diverge: compose both through these two components only.
// The browser passes its one shared query client; the server creates one
// per request so no data leaks from one visitor to another, and sends its
// cache to the browser with `dehydrate` (see entry-server.jsx, main.jsx).
export function AppRoot({ queryClient, children }) {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}

export default function AppShell({ children }) {
  return (
    <TooltipProvider>
      <Suspense fallback={<Loader />}>{children}</Suspense>
      <Toaster
        position="top-center"
        containerStyle={{ top: 16 }}
        toastOptions={{
          // La ToastBar pose ses styles en inline : seul `style` peut les surcharger.
          style: {
            background: "#ffffff",
            color: "#111b27",
            borderRadius: "16px",
            boxShadow: "var(--shadow-soft-lg)",
            padding: "14px 18px",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: 1.5,
            maxWidth: "420px",
          },
          success: {
            duration: 3000,
            iconTheme: { primary: "#059669", secondary: "#ffffff" },
          },
          // Les erreurs doivent se distinguer des succès au premier coup d'œil
          // et rester assez longtemps pour être lues depuis le bas de l'écran.
          error: {
            duration: 8000,
            iconTheme: { primary: "#dc2626", secondary: "#ffffff" },
            style: {
              background: "#fef2f2",
              color: "#7f1d1d",
              border: "1px solid #fca5a5",
            },
          },
        }}
      />
    </TooltipProvider>
  );
}
